import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import type { PageView } from '../../types';

interface LayoutProps {
    children: React.ReactNode;
    currentPage: PageView;
    pageTitle: string;
    onNavigate: (page: PageView) => void;
    onLogout: () => void;
}

export const Layout: React.FC<LayoutProps> = ({
    children,
    currentPage,
    pageTitle,
    onNavigate,
    onLogout,
}) => {
    const [sidebarOpen, setSidebarOpen] = React.useState(false);

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    const handleNavigate = (page: PageView) => {
        onNavigate(page);
        closeSidebar();
    };

    return (
        <div className="app-layout">
            {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}
            <Sidebar
                currentPage={currentPage}
                onNavigate={handleNavigate}
                onLogout={onLogout}
                isOpen={sidebarOpen}
                onClose={closeSidebar}
            />
            <main className="main-content">
                <Header title={pageTitle} onMenuToggle={toggleSidebar} onLogout={onLogout} />
                <div className="page-content">{children}</div>
            </main>
        </div>
    );
};
